import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { profileDetails } from "../../../services/ProfileService";

const OrganizationCard = () => {
  const { data } = useQuery({
    queryKey: ["profile-details"],
    queryFn: profileDetails,
  });

  const user = data?.data;
  const organization = user?.organization;


  // If no organization → show Create Company
  if (!organization) {
    return (
      <div className="bg-white p-4 rounded-lg shadow-md">
        <div className="text-sm text-gray-600 mb-3">
          You haven't created a company yet.
        </div>

        <Link
          to="/manage-company"
          className="w-full inline-flex items-center justify-center gap-2 bg-palatte text-white text-sm font-medium px-4 py-2 rounded-md hover:opacity-90 transition"
        >
          <i className="fa-regular fa-plus"></i>
          Create Company
        </Link>
      </div>
    );
  }

  const orgTitle = organization?.content?.en?.title || "Organization";
  const orgExcerpt = organization?.content?.en?.excerpt;
  const logo = organization?.logo?.url?.url || null;

  const firstLetter = orgTitle?.charAt(0)?.toUpperCase();

  return (
    <div className="bg-white rounded-lg border border-zinc-200 overflow-hidden">
      {/* Cover Image */}
      {organization?.coverImage?.url?.url && (
        <img
          src={organization.coverImage.url.url}
          alt="cover"
          className="w-full h-20 object-cover"
        />
      )}

      <div className="p-4">
        {/* Logo + Name */}
        <div className="flex items-center gap-3 -mt-8">
          {logo ? (
            <div className="w-16 h-16 rounded-md overflow-hidden border bg-white flex items-center justify-center">
              <img
                src={logo}
                alt={orgTitle}
                className="w-full h-full object-contain"
              />
            </div>
          ) : (
            <div className="w-16 h-16 rounded-md bg-gray-200 flex items-center justify-center text-lg font-semibold text-gray-600">
              {firstLetter}
            </div>
          )}

          <div className="mt-4">
            <h3 className="text-base font-bold text-gray-900">
              {orgTitle}
            </h3>
            {orgExcerpt && (
              <p className="text-xs text-gray-700 font-medium">{orgExcerpt}</p>
            )}
          </div>
        </div>

        {/* Stats */}

        {/* View Button */}
        <Link
          to={`/company/${organization?.slug}`}
          className="block mt-4 text-center text-sm font-medium text-palatte hover:underline"
        >
          View Company
        </Link>
      </div>
    </div>
  );
};

export default OrganizationCard;
